<template>
  <div>
    <el-table
      :data="dataList"
      :loading="planLoading"
      style="width: 100%; height: calc(50vh - 200px);"
      height="calc(50vh - 200px)"
    >
      <el-table-column prop="refundInstallment" label="期数" align="center"/>
      <el-table-column prop="refundName" label="款项名称" align="center"/>
      <el-table-column prop="planRefundAmount" label="计划回款金额（元）" align="center"/>
      <el-table-column prop="planRefundDate" label="计划回款日期" align="center"/>
      <el-table-column prop="accountPeriod" label="账期" align="center"/>
      <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true"/>
      <el-table-column prop="" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click="handleEditPayback(scope.row)"
            type="text"
            size="small"
          >
            备注
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="备注"
      :visible.sync="dialogVisible"
      width="500px"
      append-to-body
      :before-close="handleClose">
      <div style="margin-bottom: 20px;">说明：备注内容，限制输入200个汉字</div>
      <el-input
        type="textarea"
        :rows="4"
        :maxlength="200"
        :show-word-limit="true"
        v-model="remark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import services from '@/services/api/compact/'

export default {
  components: {},
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      dataList: [],
      planLoading: false,
      dialogVisible: false,
      remark: '',
      rowId: '',
    }
  },
  methods: {
    async handleQueryList() {
      try {
        this.planLoading = true
        const { data } = await services.apiReceivablePlanList({ contractId: this.id })
        this.dataList = data.data
      } catch (error) {
        console.log(error)
      } finally {
        this.planLoading = false
      }
    },
    handleEditPayback(row) {
      this.dialogVisible = true
      this.rowId = row.id
      this.remark = row.remark || ''
    },
    handleClose() {
      this.dialogVisible = false
      this.remark = ''
      this.rowId = ''
    },
    async handleConfirm() {
      try {
        await services.apiUpdateReceivablePlan({ id: this.rowId, remark: this.remark })
        this.handleQueryList()
      } catch (error) {
        console.log(error)
      } finally {
        this.handleClose()
      }
    },
  },
}
</script>
